import { useState } from 'react';

const PDF_URL = 'https://storage.readdy-site.link/project_files/7fd54c6e-5bf9-4b97-9111-4d2e51964b66/3cc2504c-e735-4c77-9477-f05af87495df_-roblox-secrets--free-edition--5-secrets-you-shouldnt-miss--1492i-2.pdf?v=48ba1dd35b26d96e50c18f8e09026d86';

export default function LeadMagnet() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setError('');
    setLoading(true);

    const formData = new URLSearchParams();
    formData.append('email', email);

    try {
      await fetch('https://readdy.ai/api/form/d79okuadqn9mib2tr8ng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="lead-magnet" className="bg-[#0a0a0f] py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div
          className="relative rounded-3xl border-2 border-yellow-400/40 overflow-hidden"
          style={{
            background: 'linear-gradient(160deg, #1a1a2e 0%, #0f0f1a 100%)',
            boxShadow: '0 0 60px rgba(250,204,21,0.15), 0 0 120px rgba(168,85,247,0.1)',
          }}
        >
          {/* Glow bg */}
          <div
            className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-32 rounded-full opacity-20 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse, #facc15 0%, transparent 70%)', filter: 'blur(40px)' }}
          />

          <div className="flex flex-col md:flex-row items-stretch">
            {/* Left: Guide image */}
            <div className="relative md:w-2/5 flex-shrink-0 flex items-center justify-center p-8 md:p-10">
              <div
                className="relative rounded-2xl overflow-hidden w-full max-w-[260px] mx-auto"
                style={{ boxShadow: '0 0 40px rgba(250,204,21,0.3), 0 0 80px rgba(168,85,247,0.2)' }}
              >
                <img
                  src="https://storage.readdy-site.link/project_files/7fd54c6e-5bf9-4b97-9111-4d2e51964b66/8d7fd180-96b6-4bce-97aa-f543916b17a6_Secrets-de-Roblox-dvoiles.png?v=0afa86cb78dd1a846bde621bf4fe9a38"
                  alt="Secrets de Roblox dévoilés - Free Guide"
                  className="w-full h-auto object-cover"
                />
                {/* FREE badge */}
                <div
                  className="absolute top-3 left-3 bg-yellow-400 text-black text-xs font-black uppercase tracking-wider px-3 py-1 rounded-full"
                  style={{ boxShadow: '0 0 12px rgba(250,204,21,0.7)' }}
                >
                  FREE
                </div>
              </div>
            </div>

            {/* Right: Form */}
            <div className="flex-1 p-8 md:p-10 md:pl-4 text-center md:text-left flex flex-col justify-center">
              {!submitted ? (
                <>
                  <div className="text-5xl mb-4">😳</div>
                  <h2
                    className="font-black text-white text-2xl md:text-3xl mb-3"
                    style={{ textShadow: '0 0 20px rgba(168,85,247,0.6)', fontFamily: "'Orbitron', sans-serif" }}
                  >
                    Get a FREE Secret Guide
                  </h2>
                  <p className="text-gray-400 text-sm mb-6">
                    Enter your email to instantly download the <span className="text-yellow-400 font-bold">FREE PDF</span> — 5 hidden Roblox secrets that 99% of players don&apos;t know about.
                  </p>

                  <form
                    data-readdy-form
                    id="lead-magnet-form"
                    onSubmit={handleSubmit}
                    className="flex flex-col sm:flex-row gap-3"
                  >
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email address..."
                      className="flex-1 bg-[#0a0a0f] border border-purple-700/50 text-white placeholder-gray-600 px-5 py-3.5 rounded-full text-sm focus:outline-none focus:border-purple-500 transition-colors"
                      style={{ boxShadow: 'inset 0 0 0 1px rgba(168,85,247,0.1)' }}
                      required
                    />
                    <button
                      type="submit"
                      disabled={loading}
                      className="flex items-center justify-center gap-2 bg-yellow-400 text-black font-black uppercase tracking-wider px-7 py-3.5 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-yellow-300 hover:scale-105 disabled:opacity-60 text-sm"
                      style={{ boxShadow: '0 0 20px rgba(250,204,21,0.5)' }}
                    >
                      <i className="ri-lock-unlock-line"></i>
                      {loading ? 'Sending...' : 'Unlock'}
                    </button>
                  </form>

                  {error && <p className="text-red-400 text-sm mt-3">{error}</p>}

                  <p className="text-gray-600 text-xs mt-4 flex items-center justify-center md:justify-start gap-1">
                    <i className="ri-lock-2-line"></i>
                    We respect your privacy. No spam, ever.
                  </p>
                </>
              ) : (
                <div className="py-4">
                  <div className="text-6xl mb-5">🎉</div>
                  <h3
                    className="font-black text-yellow-400 text-2xl md:text-3xl mb-3"
                    style={{ textShadow: '0 0 20px rgba(250,204,21,0.6)', fontFamily: "'Orbitron', sans-serif" }}
                  >
                    Your Free Guide is Ready!
                  </h3>
                  <p className="text-gray-300 text-base mb-6">
                    Click below to download your <strong className="text-white">FREE Roblox Secrets PDF</strong> instantly. Also check your email for a copy!
                  </p>
                  <a
                    href={PDF_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-yellow-400 text-black font-black uppercase tracking-wider px-8 py-4 rounded-full whitespace-nowrap transition-all duration-200 hover:bg-yellow-300 hover:scale-105 text-sm cursor-pointer"
                    style={{ boxShadow: '0 0 24px rgba(250,204,21,0.6)' }}
                  >
                    <i className="ri-download-2-line text-lg"></i>
                    Download Free PDF Now
                  </a>
                  <p className="text-gray-600 text-xs mt-5 flex items-center justify-center md:justify-start gap-1">
                    <i className="ri-mail-check-line text-yellow-700"></i>
                    A copy has also been sent to your email.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
